var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.$t("customers.title") } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c("v-action-buttons", {
                attrs: { items: _vm.getActionButtons },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c("h2", [
                    _vm._v(_vm._s(_vm.$t("customers.search_customer"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "filter filter--search",
                      attrs: { action: "", method: "POST", novalidation: "" },
                      on: { submit: _vm.onChangeCustomersTableFilter },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group form-group--search" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customersTableItemsFilter.search,
                                expression: "customersTableItemsFilter.search",
                              },
                            ],
                            staticClass:
                              "from-control form-control--small form-control--search",
                            attrs: {
                              type: "text",
                              name: "search",
                              placeholder: _vm.$t("search"),
                            },
                            domProps: {
                              value: _vm.customersTableItemsFilter.search,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.customersTableItemsFilter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "button",
                              attrs: {
                                role: "button",
                                type: "submit",
                                title: _vm.$t("search"),
                              },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("search")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-letter-filter", {
                    on: {
                      onClickItem: _vm.onChangeStartLetterCustomersTableFilter,
                    },
                    model: {
                      value: _vm.customersTableItemsFilter.letter,
                      callback: function ($$v) {
                        _vm.$set(_vm.customersTableItemsFilter, "letter", $$v)
                      },
                      expression: "customersTableItemsFilter.letter",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("customers.list")))]),
                  _vm._v(" "),
                  _c("v-blocks", {
                    attrs: {
                      id: "blocks",
                      isLoading: _vm.customersTableLoading,
                      items: _vm.customersTableItems,
                      useDeactivatedSwitch: true,
                      showDeactivatedOnly:
                        _vm.customersTableItemsFilter.show_deactivated_only,
                    },
                    on: {
                      onChangeShowDeactivatedOnly:
                        _vm.onChangeShowDeactivatedOnlyCustomersTableFilter,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "block",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "block block--block",
                                attrs: {
                                  to: {
                                    name: "customers-view-customer",
                                    params: { customer: row.id },
                                  },
                                  title: row.company_name,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "block--block__content" },
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(_vm._s(row.company_name)),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    row.headquarter
                                      ? [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(row.headquarter.phone)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(row.headquarter.email)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  row.headquarter.address1
                                                ) +
                                                " "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  row.headquarter.address2
                                                ) +
                                                " "
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  row.headquarter.zipcode
                                                ) +
                                                " " +
                                                _vm._s(row.headquarter.city)
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$helpers.countries[
                                                    row.headquarter.country_code
                                                  ]
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "block--block__action" },
                                  [
                                    _vm.$store.getters.userHasPermission(
                                      "customer_update"
                                    )
                                      ? [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "button gray-dark button--edit",
                                              attrs: {
                                                to: {
                                                  name: "customers-update-customer",
                                                  params: { customer: row.id },
                                                },
                                                title: _vm.$t("update"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(_vm.$t("update")) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }